import { loader } from 'graphql.macro'

export default async function createRecurringTickets ({ dataLoaders, variables }) {
  const schema = loader('./createRecurringTickets.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: { ticketParams: variables.ticketParams } })
  return response.createRecurringTickets
}
